import { request } from "./Request";
import { urlConstants } from "../utils/urlConstants";
import { Roles } from "../utils/Roles";

const { API_URL } = urlConstants;

export default class LanguageService {
  /**
   * Persist user language preference.
   * Backend contract provided: POST /api/student/language/ { language: 'en'|'es' }
   * Applies for Student and Parent per requirements.
   */
  static setUserLanguage(language = 'en', role) {
    const lang = (language || 'en').toLowerCase();
    // Endpoint provided for student; reuse for parent per spec
    const endpoint = `/api/student/language/`;
    return request("POST", `${API_URL}${endpoint}`, null, { language: lang });
  }
}
